import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { parse, isValid, isAfter, isBefore } from 'date-fns'

export const createRescissionSimulationSchema = (startPeriod: string, endPeriod: string) => {
  return yupResolver(
    yup.object({
      tipoAviso: yup
        .string()
        .oneOf(['TRABALHADO', 'INDENIZADO'], 'Tipo de aviso é obrigatório')
        .required('Tipo de aviso é obrigatório'),
      dataRescisao: yup
        .string()
        .required('Data de rescisão é obrigatória')
        .test('date-format', 'Data inválida', (value) => {
          if (!value) return false
          const date = parse(value, 'dd/MM/yyyy', new Date())
          return isValid(date)
        })
        .test('within-competence', 'Data deve estar dentro do período de competência', (value) => {
          if (!value || !startPeriod || !endPeriod) return false
          
          const selectedDate = parse(value, 'dd/MM/yyyy', new Date())
          const startDate = parse(startPeriod, 'yyyy-MM-dd', new Date())
          const endDate = parse(endPeriod, 'yyyy-MM-dd', new Date())
          
          if (!isValid(selectedDate) || !isValid(startDate) || !isValid(endDate)) {
            return false
          }
          
          return (
            (isAfter(selectedDate, startDate) || selectedDate.getTime() === startDate.getTime()) &&
            (isBefore(selectedDate, endDate) || selectedDate.getTime() === endDate.getTime())
          )
        }),
      semJustaCausa: yup.boolean().required()
    })
  )
}
